import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_TASK_STATISTIC_REQUEST = 'FETCH_TASK_STATISTIC_REQUEST';
export const FETCH_TASK_STATISTIC_SUCCESS = 'FETCH_TASK_STATISTIC_SUCCESS';
export const FETCH_TASK_STATISTIC_FAILURE = 'FETCH_TASK_STATISTIC_FAILURE';

export function fetchTaskStatistics(type, taskFilter) {
  return (dispatch) => {
    const url = buildUrl(`/tasks/${type}/statistic?isAllTasks=${taskFilter}`);
    const method = 'GET';
    return dispatch(fetchTaskStatisticRequest()).payload
      .then((response) => dispatch(fetchTaskStatisticSuccess(response)))
      .catch((error) => dispatch(fetchTaskStatisticFailure(error)));

    function fetchTaskStatisticRequest() {
      return ApiCall.createAction({
        type: FETCH_TASK_STATISTIC_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchTaskStatisticSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_TASK_STATISTIC_SUCCESS,
        payload: response,
        url,
        method,
      });
    }

    function fetchTaskStatisticFailure(error) {
      return ApiCall.createAction({
        type: FETCH_TASK_STATISTIC_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Tasks/TaskStatistic/actions.js